import { useEffect, useMemo, useState } from 'react';
import BillableMatterListing from './billableMatterListing';
import { MyInvoicingTab } from '../../interface/invoice';
import { useLocation } from 'react-router-dom';
import { usePage } from '../../context/PageContext';
import AddEditTransactionHeader from '../dashboard/addTransaction/addEditTransactionHeader';
import { useTranslation } from 'react-i18next';
import PreliminaryInvoiceListing from './preliminaryInvoiceListing';
import { useNavigationStack } from '../../context/NavigationStackContext';
import { ROUTES } from '../../constants/constants';
import CustomTabs from '../customTabs/customTabs';

const InvoicingTabView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { setTitle } = usePage();
  const { clear, push } = useNavigationStack();
  const fromTab = location?.state?.fromTab ?? MyInvoicingTab.billableMatters;
  const [selectedTab, setSelectedTab] = useState<string>(fromTab);

  const handleHome = () => {
    clear();
    push(ROUTES.DASHBOARD);
  };
  useEffect(() => {
    setTitle(
      <AddEditTransactionHeader
        title={t('common:features.myInvoicing')}
        showMenu
        showSettings
        handleHome={handleHome}
      />,
    );
  }, []);

  const items = useMemo(
    () => [
      {
        key: MyInvoicingTab.billableMatters,
        label: t('common:tab.myBillableMatters'),
        children: <BillableMatterListing />,
      },
      {
        key: MyInvoicingTab.preliminaryInvoices,
        label: t('common:tab.myPreliminaryInvoices'),
        children: <PreliminaryInvoiceListing />,
      },
    ],
    [t],
  );
  return <CustomTabs activeKey={selectedTab} onChange={setSelectedTab} items={items} />;
};

export default InvoicingTabView;
